var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.current_match.status == -2
    ? _c(
        "div",
        { staticClass: "fg-box scoreboard" },
        [
          _vm.matchStatusInfo || _vm.equation
            ? _c(
                "div",
                {
                  class: [
                    "match-equation",
                    { "add_player-of": _vm.manOfMatch || _vm.manOfSeries },
                  ],
                },
                [
                  _vm.matchStatusInfo
                    ? _c("div", { staticClass: "status" }, [
                        _vm._v(_vm._s(_vm.matchStatusInfo)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.equation
                    ? _c("div", { staticClass: "status" }, [
                        _vm._v(_vm._s(_vm.equation)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.manOfMatch || _vm.manOfSeries
                    ? _c("div", { staticClass: "player-of_match" }, [
                        _vm.manOfMatch
                          ? _c("div", { staticClass: "player_info" }, [
                              _vm._v("\n          Player of the Match:"),
                              _c("div", [_vm._v(_vm._s(_vm.manOfMatch.name))]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.manOfSeries
                          ? _c("div", { staticClass: "player_info" }, [
                              _vm._v("\n          Player of the Series:"),
                              _c("div", [_vm._v(_vm._s(_vm.manOfSeries.name))]),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !(_vm.innings && _vm.innings.length)
            ? _c("no-list", {
                attrs: {
                  toShow: "custom_message",
                  plainMsg: "Scorecard is not available for this match",
                },
              })
            : _c(
                "div",
                { staticClass: "fg-body" },
                _vm._l(_vm.innings, function (inn, i_idx) {
                  return _c("div", { key: i_idx, staticClass: "text" }, [
                    _c("div", { staticClass: "team-name" }, [
                      _c("div", { staticClass: "team-a" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.getTeamName(inn.Battingteam, inn.Number))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "score" }, [
                        _c("strong", [
                          _vm._v(
                            _vm._s(inn.Total) +
                              "/" +
                              _vm._s(inn.Wickets) +
                              _vm._s(inn.Isdeclared ? " d" : "") +
                              " "
                          ),
                        ]),
                        _vm._v("(" + _vm._s(inn.Overs) + ")\n        "),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "table-responsive table-scoreboard points-table",
                      },
                      [
                        _c("table", { staticClass: "table" }, [
                          _c("thead", [
                            _c(
                              "tr",
                              _vm._l(_vm.batCols, function (col, bat_idx) {
                                return _c(
                                  "th",
                                  {
                                    key: bat_idx,
                                    class: [
                                      { num: col.isNumber },
                                      { "align-left": !col.isNumber },
                                    ],
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(col.name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(inn.Batsmen, function (plyr, plyr_idx) {
                                return _c(
                                  "tr",
                                  { key: plyr_idx },
                                  _vm._l(_vm.batCols, function (col, bat_idx) {
                                    return _c(
                                      "td",
                                      {
                                        key: bat_idx,
                                        class: [
                                          { num: col.isNumber },
                                          { "align-left": !col.isNumber },
                                          { "wkt-taker": col.isHowOut },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              col.isName
                                                ? _vm.getPlayerName(
                                                    inn.Battingteam,
                                                    plyr[col.key],
                                                    true
                                                  )
                                                : col.isNumber
                                                ? _vm.numberValue(plyr[col.key])
                                                : plyr[col.key]
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              }),
                              _vm._v(" "),
                              _c("tr", { staticClass: "extras" }, [
                                _c("td", [_vm._v("Extras")]),
                                _vm._v(" "),
                                _c("td", { staticClass: "align-right" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.countExtras(
                                          inn.Noballs,
                                          inn.Wides,
                                          inn.Byes,
                                          inn.Legbyes
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "align-left",
                                    attrs: { colspan: "5" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                ( NB " +
                                        _vm._s(inn.Noballs) +
                                        ", WD " +
                                        _vm._s(inn.Wides) +
                                        ", B " +
                                        _vm._s(inn.Byes) +
                                        ",\n                LB " +
                                        _vm._s(inn.Legbyes) +
                                        " )\n              "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("tr", { staticClass: "total-run" }, [
                                _c("td", [_vm._v("Total Runs")]),
                                _vm._v(" "),
                                _c("td", { staticClass: "align-right" }, [
                                  _vm._v(_vm._s(inn.Total)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "align-left",
                                    attrs: { colspan: "5" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                ( " +
                                        _vm._s(inn.Wickets) +
                                        " wkts, " +
                                        _vm._s(inn.Overs) +
                                        " ov )\n              "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              inn.FallofWickets && inn.FallofWickets.length
                                ? _c("tr", { staticClass: "wkt-fall" }, [
                                    _c("td", { attrs: { colspan: "7" } }, [
                                      _c("div", { staticClass: "tr-title" }, [
                                        _vm._v(
                                          "\n                  Fall of wickets\n                  "
                                        ),
                                        _c(
                                          "div",
                                          _vm._l(
                                            inn.FallofWickets,
                                            function (fow, fow_idx) {
                                              return _c(
                                                "span",
                                                {
                                                  key: fow_idx,
                                                  staticClass: "out-player",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(fow.Score) +
                                                        "/" +
                                                        _vm._s(fow.Wicket_No)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    { staticClass: "player" },
                                                    [
                                                      _vm._v(
                                                        "\n                        ( " +
                                                          _vm._s(
                                                            _vm.getPlayerName(
                                                              inn.Battingteam,
                                                              fow.Batsman
                                                            )
                                                          ) +
                                                          ",\n                        " +
                                                          _vm._s(fow.Overs) +
                                                          " ov )"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ]),
                                  ])
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    inn.Bowlers && inn.Bowlers.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "table-responsive table-scoreboard points-table",
                          },
                          [
                            _c("table", { staticClass: "table" }, [
                              _c("thead", [
                                _c(
                                  "tr",
                                  _vm._l(_vm.bowlCols, function (col, bat_idx) {
                                    return _c(
                                      "th",
                                      {
                                        key: bat_idx,
                                        class: [
                                          { num: col.isNumber },
                                          { "align-left": !col.isNumber },
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(col.name) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(inn.Bowlers, function (plyr, plyr_idx) {
                                  return _c(
                                    "tr",
                                    { key: plyr_idx },
                                    _vm._l(
                                      _vm.bowlCols,
                                      function (col, bat_idx) {
                                        return _c(
                                          "td",
                                          {
                                            key: bat_idx,
                                            class: [
                                              { num: col.isNumber },
                                              { "align-left": !col.isNumber },
                                              { "wkt-taker": col.isHowOut },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  col.isName
                                                    ? _vm.getPlayerName(
                                                        inn.Bowlingteam,
                                                        plyr[col.key],
                                                        false
                                                      )
                                                    : col.isNumber
                                                    ? _vm.numberValue(
                                                        plyr[col.key]
                                                      )
                                                    : plyr[col.key]
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                }),
                                0
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ])
                }),
                0
              ),
        ],
        1
      )
    : _c("div", { staticClass: "fg-box scoreboard" }, [
        _c(
          "div",
          { staticClass: "table-responsive table-scoreboard points-table" },
          [
            _c("table", { staticClass: "table squad" }, [
              _vm.squads.thead && _vm.squads.thead.length
                ? _c(
                    "thead",
                    _vm._l(_vm.squads.thead, function (th, th_idx) {
                      return _c("tr", { key: th_idx }, [
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(th.t1)),
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(th.t2)),
                        ]),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.squads.tbody && _vm.squads.tbody.length
                ? _c(
                    "tbody",
                    _vm._l(_vm.squads.tbody, function (tr, tr_idx) {
                      return _c("tr", { key: tr_idx }, [
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(tr.t1)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _vm._v(_vm._s(tr.t2)),
                        ]),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }